import { cx } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

interface Props extends ComponentPropsWithoutRef<'section'> {
  readonly children: ReactNode;
  readonly padTop?: boolean;
  readonly screen?: boolean;
  readonly id?: string;
}

const Section = ({
  children,
  padTop,
  screen,
  id,
  className = '',
  ...props
}: Props): JSX.Element => (
  <section
    data-cy="lp-section"
    className={cx(
      'pb-20 lg:pb-24',
      {
        'min-h-screen': screen,
        'pt-20 lg:pt-24': padTop,
      },
      className,
    )}
    id={id}
    {...props}
  >
    {children}
  </section>
);

export default Section;
